import { ComponentPropsWithoutRef, forwardRef } from 'react';
import FormField from './FormField';
import { controlClasses } from './controlClasses';

type Props = ComponentPropsWithoutRef<'input'> & {
  label?: string;
  error?: string;
};

const FormInput = forwardRef<HTMLInputElement, Props>(
  ({ label, id, error, className, ...props }, ref) => (
    <FormField id={id} label={label} error={error}>
      <input
        ref={ref}
        id={id}
        aria-invalid={error ? true : undefined}
        aria-describedby={error && id ? `${id}-error` : undefined}
        className={controlClasses(!!error, className)}
        {...props}
      />
    </FormField>
  )
);

FormInput.displayName = 'FormInput';

export default FormInput;
